// Generated from SVG to Code Figma Plugin

export const Copy = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.26855 6.47683V4.07104C7.26855 3.26203 7.92439 2.6062 8.7334 2.6062H21.4287C22.2377 2.6062 22.8936 3.26203 22.8936 4.07104V16.7664C22.8936 17.5754 22.2377 18.2312 21.4287 18.2312H18.9958"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M17.2666 6.7688H4.57129C3.76228 6.7688 3.10645 7.42463 3.10645 8.23364V20.929C3.10645 21.738 3.76228 22.3938 4.57129 22.3938H17.2666C18.0756 22.3938 18.7314 21.738 18.7314 20.929V8.23364C18.7314 7.42463 18.0756 6.7688 17.2666 6.7688Z"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
